import React from 'react';

const ContactUs = () => {
  return (
    <div>
      <h1>I am contact us page</h1>
    </div>
  );
};

export default ContactUs;
